import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { Avatar } from '@mssgme/ui';

import styles from './AssignOption.scss';

const AvatarType = PropTypes.shape({
    name: PropTypes.string,
    src: PropTypes.string,
});

const MetaType = PropTypes.shape({
    avatar: AvatarType,
    icon: PropTypes.elementType,
    count: PropTypes.number,
});

AssignOption.propTypes = {
    className: PropTypes.string,
    as: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
    meta: MetaType,
};

AssignOption.defaultProps = {
    isSelected: false,
    as: 'li',
    meta: {},
};

export default function AssignOption({ className, as: Element, value, label, onSelect, isSelected, meta }) {
    const { avatar, icon, count } = meta;

    const handleClick = (e) => {
        e.preventDefault();
        onSelect(value);
    };

    let prefix;

    if (avatar) {
        prefix = <Avatar className={styles.avatar} fontSize={12} size={24} {...avatar} />;
    } else if (icon) {
        prefix = <BaseIcon className={styles.icon} icon={icon} size={22} />;
    }

    return (
        <Element
            className={cn(styles.root, className, {
                [styles.active]: isSelected,
            })}
            onClick={handleClick}
            role="button"
        >
            {prefix && <div className={styles.prefix}>{prefix}</div>}
            <div className={styles.label}>{label}</div>
            {count != null && <div className={styles.count}>{count}</div>}
        </Element>
    );
}

// eslint-disable-next-line react/prop-types
function BaseIcon({ icon: Component, ...props }) {
    return <Component {...props} />;
}
